import { Core, Decorative } from "@faire/design-tokens";
import { trackInsiderLoggedOutInsiderMarketingPageView } from "@faire/web-api/events/insider/view/loggedOutInsiderMarketingPage";
import { useStrictLocalization } from "@faire/web/common/localization";
import * as React from "react";
import { useEffect } from "react";

import { RetailerFooter } from "@faire/retailer/components/Footer/RetailerFooter";
import { FaireHelmet } from "@faire/retailer/components/Helmet";
import { TestimonialsCardSection } from "@faire/retailer/components/TestimonialsCardSection/TestimonialsCardSection";
import { useInsiderFeatureEligibility } from "@faire/retailer/hooks/insider/useInsiderFeatureEligibility";
import { getSettingInsiderMarketingPageImageUrls } from "@faire/retailer/settings/getSettingInsiderMarketingPageImageUrls";

import { InsiderFAQSection } from "../InsiderMembership/InsiderSetting/InsiderFAQSection";

import { HeroBanner } from "./components/HeroBanner";
import { InsiderBenefitsOverviewRenderer } from "./components/InsiderBenefitsOverview/InsiderBenefitsOverviewRenderer";
import { InsiderBrandCarousel } from "./components/InsiderBrandCarousel";
import { InsiderEarlyAccessBanner } from "./components/InsiderEarlyAccessBanner";
import { InsiderFooter } from "./components/InsiderFooter";
import { InsiderHowToUse } from "./components/InsiderHowToUse/InsiderHowToUse";
import { InsiderPhoneSupportSection } from "./components/InsiderPhoneSupportSection";
import { InsiderProtectedEarlyAccessBanner } from "./components/InsiderProtectedEarlyAccessBanner";
import { InsiderSavingsBanner } from "./components/InsiderSavingsBanner";
import {
  TestimonialTitle,
  useTestimonials,
} from "./components/TestimonialTitle";

export const LoggedOutInsiderMarketingPage: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const { hasProtectedEarlyAccessPerk } = useInsiderFeatureEligibility();
  const testimonials = useTestimonials();

  useEffect(() => {
    trackInsiderLoggedOutInsiderMarketingPageView();
  }, []);

  return (
    <>
      <FaireHelmet
        title={strictLocalize({
          defaultMessage: "Get free shipping with Faire Insider",
          description: {
            text: "Title for the Faire Insider Marketing Page",
          },
        })}
        description={strictLocalize({
          defaultMessage:
            "Insider is the best way to shop on Faire. Sign up for Faire today and unlock a free trial of Insider.",
          description: {
            text: "Description for the Faire Insider Marketing Page",
          },
        })}
      />
      <HeroBanner />
      <InsiderBenefitsOverviewRenderer />
      <InsiderSavingsBanner />
      <InsiderBrandCarousel />
      {hasProtectedEarlyAccessPerk ? (
        <InsiderProtectedEarlyAccessBanner />
      ) : (
        <InsiderEarlyAccessBanner />
      )}
      <InsiderPhoneSupportSection />
      <InsiderHowToUse imageUrls={getSettingInsiderMarketingPageImageUrls()} />
      <TestimonialsCardSection
        title={<TestimonialTitle />}
        testimonials={testimonials}
        backgroundColor={Decorative.tint.teal}
        textColor={Core.text.default}
      />
      <InsiderFAQSection />
      <InsiderFooter />
      <RetailerFooter />
    </>
  );
};
